import React from 'react'
import s from '../Tray/Tray.scss'
import { nodes } from '../Flow.data'
import sText from 'components/Text/Text.scss'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import Button from '@pickle/pickle-shared/src/components/Button/Button'

export default ({ selected, saveNode, model, flow }) => (
  <div className={cn(sLay.flex, sLay['layout-column'], { [s.hidden]: !selected })}>
    {model.serializeDiagram().nodes.map(node => {
      const nodeInfo = nodes[node.type]
      return (
        <div
          key={node.id}
          className={cn(
            { [s.hidden]: !selected || selected.id !== node.id },
            sLay.flex,
            sLay['layout-column']
          )}
        >
          <div className={cn(s.selectedTitle, sText.descrip3)}>{nodeInfo.label}</div>
          <div className={cn(sLay['layout-column'], sLay.flex)} style={{ overflowY: 'auto' }}>
            <nodeInfo.form
              form={node.id}
              className={cn(s.selectedBody, sLay.flex, sLay['layout-column'])}
              onSubmit={saveNode}
              node={node}
              nodeInfo={nodeInfo}
              initialValues={node.extras}
              flow={flow}
            />
            {/*<div className={sLay.flex} />*/}
          </div>
          <div className={sLay['layout-column']} style={{ margin: '20px 20px 0 20px' }}>
            <Button color="warn" rect onClick={() => selected && selected.remove()}>
              Delete Node
            </Button>
          </div>
        </div>
      )
    })}
  </div>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/TraySelected/TraySelected.jsx